import { render, staticRenderFns } from "./CustomerCategoryForm.vue?vue&type=template&id=0fcdfb8c&scoped=true"
import script from "./CustomerCategoryForm.vue?vue&type=script&lang=js"
export * from "./CustomerCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerCategoryForm.vue?vue&type=style&index=0&id=0fcdfb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdfb8c",
  null
  
)

export default component.exports